"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const fileSizeDisplay = size => {
  const suffixIndex = size ? Math.floor(Math.log(size) / Math.log(1024)) : 0;
  const displaySize = Number(size / Math.pow(1024, suffixIndex)).toFixed(2).replace(/\.00$/, '');
  const suffix = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][suffixIndex];
  return `${displaySize} ${suffix || ''}`;
};

const isFileEncrypted = async (fileHandle, onError) => {
  const {
    file
  } = fileHandle;

  try {
    if (file.type === 'application/pdf') {
      const fileContents = await file.text();
      return fileContents.indexOf('/Encrypt') !== -1;
    }
  } catch (e) {
    if (onError) {
      onError(e, fileHandle);
    }
  }

  return false;
};

const FileUploadButton = (0, _mobxReact.observer)(({
  allowFilePassword,
  dataTestId,
  className,
  buttonClassName,
  label = 'Upload',
  variant,
  disabled,
  small,
  loading,
  tooltipMessage,
  tooltipPosition,
  maxFileSize,
  acceptedFiletypes,
  onError,
  onPasswordProtectedError,
  onFilesChanged,
  icon
}) => {
  const inputRef = (0, _react.createRef)();
  return _react.default.createElement("span", {
    "data-testid": dataTestId,
    className: className
  }, _react.default.createElement("input", {
    "data-testid": dataTestId && `${dataTestId}-input`,
    ref: inputRef,
    type: `file`,
    hidden: true,
    multiple: true,
    accept: Array.isArray(acceptedFiletypes) ? acceptedFiletypes.join(',') : acceptedFiletypes,
    onChange: async event => {
      var _a;

      if ((_a = event.target.files) === null || _a === void 0 ? void 0 : _a.length) {
        const eventFiles = Array.from(event.target.files);
        const filesWErrors = [];
        const errorMessage = 'Uploaded files cannot be password protected';
        const files = await Promise.all(eventFiles.map(async file => {
          const handle = new _.FileHandle(file);

          if (maxFileSize !== undefined && handle.size > maxFileSize) {
            handle.setError(`File exceeds maximum size of ${fileSizeDisplay(maxFileSize)}`);
          } else if (!allowFilePassword && (await isFileEncrypted(handle, onError))) {
            handle.setError(errorMessage);
            filesWErrors.push(handle);
          }

          return handle;
        }));
        onFilesChanged(files);
        onPasswordProtectedError && onPasswordProtectedError(errorMessage, filesWErrors.map(file => file.name));
      }
    }
  }), _react.default.createElement(_.Button, {
    dataTestId: dataTestId && `${dataTestId}-button`,
    className: buttonClassName,
    label: icon ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_.Icon, {
      name: icon,
      color: disabled ? _.Color.neutral._60 : _.Color.blue._60,
      size: 22
    }), ' ', label) : label,
    variant: variant,
    disabled: disabled,
    small: small,
    loading: loading,
    tooltipMessage: tooltipMessage,
    tooltipPosition: tooltipPosition,
    onClick: () => {
      var _a;

      return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }
  }));
});
var _default = FileUploadButton;
exports.default = _default;